module.exports = __webpack_public_path__ + "media/images/pc/stores/omiya/omiya_concept_01-4632773dda6ad505e066ac6ae26c2067.jpg";